import { render, staticRenderFns } from "./partnersFlex.vue?vue&type=template&id=3a02149e&scoped=true&"
import script from "./partnersFlex.vue?vue&type=script&lang=js&"
export * from "./partnersFlex.vue?vue&type=script&lang=js&"
import style0 from "./partnersFlex.vue?vue&type=style&index=0&id=3a02149e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a02149e",
  null
  
)

export default component.exports